import { http } from "../utils/http";

export const getHiredEmployees = (department = null, { activeOnly = true } = {}) => {
    const params = new URLSearchParams();
    if (department) params.set("department", department);
    if (activeOnly === false) params.set("active_only", "false");
    const qs = params.toString();
    return http.get(`/employees${qs ? `?${qs}` : ""}`);
};

export const getVnrHires = ({ hrUserId = null, activeOnly = true, mine = false } = {}) => {
    const params = new URLSearchParams();
    if (hrUserId) params.set("hr_user_id", String(hrUserId));
    if (activeOnly === false) params.set("active_only", "false");
    if (mine) params.set("mine", "true");
    const qs = params.toString();
    return http.get(`/vnr-hires${qs ? `?${qs}` : ""}`);
};

export const getEmployee = (id) => http.get(`/employees/${id}`);
export const getEmployeeDocumentDetails = (id) => http.get(`/employees/${id}/document-details`);
export const updateEmployeeDocumentDetails = (id, data) => http.patch(`/employees/${id}/document-details`, data);

export const createEmployee = (data) => http.post("/employees", data);

export const importEmployees = (file) => {
    const form = new FormData();
    form.append("file", file);
    return http.post("/employees/import", form);
};

export const getFamilies = (employeeId = null) => {
    const query = employeeId ? `?employee_id=${encodeURIComponent(employeeId)}` : "";
    return http.get(`/families${query}`);
};

export const createFamily = (data) => http.post("/families", data);
export const updateFamily = (id, data) => http.patch(`/families/${id}`, data);
export const deleteFamily = (id) => http.del(`/families/${id}`);
export const importFamilies = (file) => {
    const form = new FormData();
    form.append("file", file);
    return http.post("/families/import", form);
};

export const getEmployeeExcelCatalog = () => http.get("/employee-excel/catalog");
export const previewEmployeeExcel = (data) => http.post("/employee-excel/preview", data);
export const exportEmployeeExcel = (data) => http.postBlob("/employee-excel/export", data);

export const updateEmployee = (id, data) => http.patch(`/employees/${id}`, data);
export const createEmployeeErpAccount = (id, data) => http.post(`/employees/${id}/erp-account`, data);

export const terminateEmployee = (id, data) => http.post(`/employees/${id}/terminate`, data);
export const restoreEmployee = (id) => http.post(`/employees/${id}/restore`, {});

export const getEmployeeContacts = (id) => http.get(`/employees/${id}/contacts`);
export const getEmployeeDepartmentContacts = (id) => http.get(`/employees/${id}/department-contacts`);
export const selectEmployeeDepartmentContact = (id, contactId) => http.put(`/employees/${id}/department-contact`, { contact_id: contactId });
export const createEmployeeContact = (id, data) => http.post(`/employees/${id}/contacts`, data);
export const updateContact = (id, data) => http.patch(`/contacts/${id}`, data);
export const deactivateContact = (id) => http.del(`/contacts/${id}`);
export const getOrganizationDepartments = () => http.get("/organization/departments");
export const getOrganizationDepartment = (id) => http.get(`/organization/departments/${id}`);
export const updateDepartmentLead = (id, employeeId) => http.put(`/organization/departments/${id}/lead`, { employee_id: employeeId });
export const createDepartmentContact = (id, data) => http.post(`/organization/departments/${id}/contacts`, data);

export const getApprovals = ({ candidateId, vacancyId } = {}) => {
    const params = new URLSearchParams();
    if (candidateId) params.set("candidate_id", String(candidateId));
    if (vacancyId) params.set("vacancy_id", String(vacancyId));
    const qs = params.toString();
    return http.get(`/approvals${qs ? `?${qs}` : ""}`);
};

export const createApproval = (data) => http.post("/approvals", data);

export const getAuditLogs = ({ entityType, entityId, limit = 100 } = {}) => {
    const params = new URLSearchParams();
    if (entityType) params.set("entity_type", entityType);
    if (entityId != null) params.set("entity_id", String(entityId));
    params.set("limit", String(limit));
    return http.get(`/audit-logs?${params.toString()}`);
};

export const getCandidateStageHistory = (candidateId) =>
    http.get(`/candidate/${candidateId}/stage-history`);

export const getCandidateComments = (candidateId) =>
    http.get(`/candidate/${candidateId}/comments`);

export const createCandidateComment = (candidateId, data) =>
    http.post(`/candidate/${candidateId}/comments`, data);

export const deleteCandidateComment = (candidateId, commentId) =>
    http.del(`/candidate/${candidateId}/comments/${commentId}`);

export const getCompanyContacts = () => http.get("/company_contacts");

export const createCompanyContact = (data) => http.post("/company_contacts", data);

export const updateCompanyContact = (id, data) => http.put(`/company_contacts/${id}`, data);

export const deleteCompanyContact = (id) => http.del(`/company_contacts/${id}`);

/** Adaptation summary per employee for the employees table (правка №15, Чат 4). [Claude] 2026-11-02 */
export const getEmployeesAdaptationSummary = () => http.get("/employees-table/adaptation");
/** Контакты всех сотрудников для таблицы и поиска; единый вид телефонов (доработка №15, 04.11). [Claude] 2026-11-04 */
export const getEmployeesTableContacts = () => http.get("/employees-table/contacts");
export const normalizeEmployeePhones = (apply = false) => http.post(`/employees-table/phones/normalize${apply ? "?apply=true" : ""}`, {});

/** Employee card (правка №15, Чат 4, MR 2). [Claude] 2026-11-02 */
export const getEmployeesAccess = () => http.get("/employees-table/me");
export const getEmployeeOverview = (employeeId) => http.get(`/employees-table/${employeeId}/overview`);
export const saveEmployeeResumeLink = (employeeId, url) => http.put(`/employees-table/${employeeId}/resume-link`, { url });
// Несколько резюме у сотрудника (правка №15, MR 4). [Claude] 2026-11-02
export const addEmployeeResume = (employeeId, { url, title = "" }) => http.post(`/employees-table/${employeeId}/resumes`, { url, title });
export const updateEmployeeResume = (employeeId, resumeId, body) => http.patch(`/employees-table/${employeeId}/resumes/${resumeId}`, body);
export const deleteEmployeeResume = (employeeId, resumeId) => http.del(`/employees-table/${employeeId}/resumes/${resumeId}`);
